import React, { useEffect } from 'react';
import { useLandlordStore } from '@/stores/useLandlordStore';
import { Loader2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { LandlordPropertyCard } from '@/components/cards/LandlordPropertyCard';

export const PropertyList: React.FC = () => {
    const navigate = useNavigate();
    const { properties, loading, fetchProperties } = useLandlordStore();

    useEffect(() => {
        fetchProperties();
    }, []);

    const paymentPlanLabel = 'Free'; // TODO: fetch plan from API / user profile
    const filtered = properties;

    if (loading && !properties.length) {
        return (
            <div className="flex items-center justify-center py-20">
                <Loader2 className="animate-spin text-primary" size={32} />
            </div>
        );
    }

    return (
        <div className="space-y-6">
            <div className="flex items-center justify-between px-2 py-4">
                <p className="text-xs font-semibold tracking-wide text-light-subtle dark:text-dark-subtle uppercase">
                    All Properties
                </p>
                <div className="flex items-center gap-2 bg-light-card/80 dark:bg-dark-card/80 px-4 py-1.5 rounded-full">
                    <span className="text-xs font-medium text-light-text dark:text-dark-text">Plan:</span>
                    <span className="text-xs font-semibold text-primary">{paymentPlanLabel}</span>
                </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {filtered.length === 0 ? (
                    <div className="col-span-full py-12 text-center bg-light-card dark:bg-dark-card rounded-xl border border-dashed border-light-border dark:border-dark-border">
                        <p className="text-lg font-medium text-light-text dark:text-dark-text">No properties found</p>
                        <p className="text-sm text-light-subtle dark:text-dark-subtle mt-2">Start by adding one using the "+" button in the top bar.</p>
                    </div>
                ) : (
                    filtered.map((property) => (
                        <LandlordPropertyCard
                            key={property.id}
                            property={property}
                            onClick={() => navigate(`/landlord/properties/${property.id}`)}
                        />
                    ))
                )}
            </div>
        </div>
    );
};
